import React, { useState } from 'react';
import {find} from 'lodash';
import './Report.scss';
import { IoMdCloseCircle } from 'react-icons/io';
import { useDispatch, useSelector } from 'react-redux';
import { sendReport } from '../../actions/reportActions';
import { SUCCESS_PAGE } from '../../actions/constantsActions';

export default function Report() {
  const [image, setImage] = useState('');
  const [message, setMessage] = useState('');
  const [file, setFile] = useState(null);
  const [errMessage, setErrorMessage] = useState('');
  const cars = useSelector((state) => state.cars);
  const reservationId = useSelector((state) => state.report.reservationId);
  const dispatch = useDispatch();

  const handleRemove = () => {
    setImage('');
  };

  const handleUpload = (e) => {
    const fileReader = new FileReader();
    const fileImage = e.target.files[0];
    e.target.value = null;
    setFile('');
    if (fileImage && fileImage.type.match('image.*')) {
      fileReader.readAsDataURL(fileImage);
    }
    fileReader.onloadend = () => {
      setImage(fileReader.result);
      setFile(fileImage);
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData();

    const activeCar = find(cars, car => car.active === true)
    formData.append('photo', file);
    dispatch(sendReport(formData, message, reservationId, activeCar.plateNo))
      .then(() => {
        dispatch({
          type: SUCCESS_PAGE
        });
      })
      .catch(() => {
        setErrorMessage('Odeslání se nezdařilo.');
      });
  };

  const handleChange = (e) => {
    setMessage(e.target.value);
  };

  return (
    <div className="report-container">
      <form onSubmit={handleSubmit} method="post">
        <div className="report-upload__container">
          <label htmlFor="upload" className="report-upload__button">
            Přidat fotku
            <i className="fa fa-camera report-camera__icon" />
            <input
              id="upload"
              label="upload"
              className="report-upload__input"
              type="file"
              onChange={handleUpload}
            />
          </label>
        </div>
        {image && (
          <div className="report-image__container">
            <img className="report-image" alt="" id="output" src={image} />
            <IoMdCloseCircle
              className="report-icon__cross"
              onClick={handleRemove}
            />
          </div>
        )}
        <div className="input-error">{errMessage}</div>
        <textarea
          id="messageText"
          maxLength="450"
          placeholder="Popis problému"
          className="report-file__text"
          onChange={handleChange}
        />
        <div className="report-button__container">
          <button type="submit" className="report-button btn">
            Nahlásit
          </button>
        </div>
      </form>
    </div>
  );
}
